import { defineMessages } from 'react-intl';

export const trelloI18nMessages = defineMessages({
	successTitle: {
		id: 'highlight-actions.trello.create.success',
		defaultMessage: 'Trello card created',
		description: 'The text is shown as the title of a success flag notification after a Trello card has been successfully created from highlighted page text.',
	},
	errorTitle: {
		id: 'highlight-actions.trello.create.error',
		defaultMessage: "Couldn't create Trello card. Try again later.",
		description: 'The text is shown as the title of an error flag notification when creating a Trello card from highlighted page text fails, prompting the user to try again later.',
	},
	openCard: {
		id: 'highlight-actions.trello.openCard',
		defaultMessage: 'Open card',
		description: 'The text is shown as a link action in the success flag notification after a Trello card has been created from highlighted text. Clicking it opens the newly created Trello card in a new tab.',
	},
});
